import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-heading',
  standalone: true,
  imports: [],
  templateUrl: './heading.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './heading.component.scss',
})
export class HeadingComponent {
  heading: string = 'Log ind';
}
